mobileSize = 1200;

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1200) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1201) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Search Box
  $('.searchBox').hover(function(){
		$('.nav').fadeOut();
	},
	function(){
		$('.nav').fadeIn();
	});

  // Email Signup
  $('.homepage .emailSignup .textbox')
    .attr('value', 'Email Address')
    .attr('onclick', 'ClearDefaultText(this, "Email Address")');
  $('.homepage .emailSignup .emailSubmitButton').text('Subscribe');

  // Footer
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems2').appendTo('.footer-right');
  } else {
    $('.footerItems2').appendTo('.footer-left');
  }
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});

$(window).resize(function(){
  // Footer
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems2').appendTo('.footer-right');
  } else {
    $('.footerItems2').appendTo('.footer-left');
  }
});